import {
  HStack,
  IconButton,
  Select,
  Spacer,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { TableIcon, TableRowsSplitIcon, X } from "lucide-react";
import { useEffect, useState } from "react";

export function MultiSelect(props: {
  title: string;
  values: Array<string | number>;
  displayValues: Array<string>;
  onChange: (selection: Array<string | number>, jointTable: boolean) => void;
  hideTitle?: boolean;
  hideSplitCheckbox?: boolean;
  direction?: "column" | "row";
  defaultEmptyOption?: string;
}) {
  const [jointTable, setJointTable] = useState<boolean>(true);
  const [selectionArray, setSelectionArray] = useState<Array<string | number>>(
    []
  );

  useEffect(() => {
    if (!jointTable && selectionArray.length === 0) {
      setSelectionArray(props.displayValues);
    }
  }, [jointTable]);

  useEffect(() => {
    const selectedIndices = props.displayValues
      .map((v, i) => (selectionArray.includes(v) ? i : null))
      .filter((e) => e != null);
    const selectedValues = props.values.filter((v, i) =>
      selectedIndices.includes(i)
    );
    props.onChange(selectedValues, jointTable);
  }, [selectionArray, jointTable]);

  return (
    <Stack direction={props.direction ?? "column"}>
      {!props.hideTitle && <Text>{props.title}</Text>}
      <HStack>
        {!props.hideSplitCheckbox && (
          <TableSplitCheckbox
            joinState={jointTable}
            onChange={() => {
              setJointTable((old) => !old);
            }}
          />
        )}

        <Select
          minW={100}
          placeholder={
            selectionArray.length === 0 ? props.defaultEmptyOption ?? "-" : "-"
          }
          onChange={(event) => {
            const newVal = event.target?.value;
            if (newVal == null || newVal.length === 0) {
              return;
            }
            setSelectionArray((old) => {
              return [...old.filter((e) => e !== newVal), newVal];
            });
          }}
        >
          {props.values
            .map((e, i) => [e, props.displayValues[i], i])
            .filter((v) => !selectionArray.includes(v[1]))
            .map((v) => {
              const val = v[0];
              const dispVal = v[1];
              return (
                <option key={val} value={dispVal}>
                  {dispVal}
                </option>
              );
            })}
        </Select>
      </HStack>
      <Stack
        direction={props.direction ?? "column"}
        align={"right"}
        spacing={0}
      >
        {props.values
          .map((e, i) => [e, props.displayValues[i], i])
          .filter((v) => selectionArray.includes(v[1]))
          .map((v) => {
            const val = v[0];
            const dispVal = v[1];
            return (
              <HStack
                padding="5px"
                margin={jointTable && !props.hideSplitCheckbox ? "0px" : "5px"}
                borderRadius={jointTable ? "0px" : "5px"}
                key={val}
                background={"blue.200"}
                align={"center"}
              >
                <Text fontSize={"18px"}>{dispVal}</Text>
                <Spacer />
                <IconButton
                  aria-label={`close-${val}`}
                  icon={<X />}
                  variant={"ghost"}
                  size={"xs"}
                  onClick={() => {
                    setSelectionArray((oldArray) => {
                      return oldArray.filter((e) => e !== dispVal);
                    });
                  }}
                />
              </HStack>
            );
          })}
      </Stack>
    </Stack>
  );
}

function TableSplitCheckbox(props: {
  joinState: boolean;
  onChange: (join: boolean) => void;
}) {
  return (
    <IconButton
      aria-label="split-data-over-multi-table-toggle"
      icon={props.joinState ? <TableIcon /> : <TableRowsSplitIcon />}
      variant={"ghost"}
      size={"xs"}
      onClick={() => {
        props.onChange(props.joinState);
      }}
    />
  );
}
